const manageReservationTypes = {
  GET_MANAGERESERVATIONDETAILS_REQUEST: 'FETCH_MANAGE_RESERVATION_DETAILS_REQUEST',
  GET_MANAGERESERVATIONDETAILS_SUCCESS: 'FETCH_MANAGE_RESERVATION_DETAILS_SUCCESS',
  GET_MANAGERESERVATIONDETAILS_FAILURE: 'FETCH_MANAGE_RESERVATION_DETAILS_FAILURE',
  UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_SUCCESS:
    'UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_SUCCESS',
  UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_CLEAR: 'UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_CLEAR',
  UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR: 'UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR',
  UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR_CLEAR:
    'UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR_CLEAR',
  GET_COMPARISON_CHANGES_REQUEST: 'GET_COMPARISON_CHANGES_REQUEST',
  GET_COMPARISON_CHANGES_SUCCESS: 'GET_COMPARISON_CHANGES_SUCCESS',
  GET_COMPARISON_CHANGES_FAILURE: 'GET_COMPARISON_CHANGES_FAILURE',
  GET_COMPARISON_CHANGES_CLEAN: 'GET_COMPARISON_CHANGES_CLEAN',
  GET_RESERVATION_BY_ID_AND_LAST_NAME_SUCCESS: 'GET_RESERVATION_BY_ID_AND_LAST_NAME_SUCCESS',
  CLEAR_MANAGERESERVATIONDETAILS: 'CLEAR_MANAGERESERVATIONDETAILS',
  FETCH_RESERVATION_ADD_ONS_REQUEST: 'FETCH_MANAGE_RESERVATION_ADD_ONS_REQUEST',
  FETCH_RESERVATION_ADD_ONS_SUCCESS: 'FETCH_MANAGE_RESERVATION_ADD_ONS_SUCCESS',
  FETCH_RESERVATION_ADD_ONS_FAILURE: 'FETCH_MANAGE_RESERVATION_ADD_ONS_FAILURE',
  CLEAR_RESERVATION_PACKAGES_UPDATE: 'CLEAR_RESERVATION_PACKAGES_UPDATE',
  FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS: 'FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS',
  CLEAR_RESERVATION_DETAILS_DETAILS_ERROR: 'CLEAR_RESERVATION_DETAILS_DETAILS_ERROR',
  CLEAR_RESERVATION_DETAILS_PACKAGE_MESSAGE_ERROR: 'CLEAR_RESERVATION_DETAILS_PACKAGE_MESSAGE_ERROR',
  RESERVATION_DETAILS_CABANA_IS_LOADING: 'RESERVATION_DETAILS_CABANA_IS_LOADING',
  RESERVATION_DETAILS_CABANA_SUCCESS: 'RESERVATION_DETAILS_CABANA_SUCCESS',
  RESERVATION_DETAILS_CABANA_FAILURE: 'RESERVATION_DETAILS_CABANA_FAILURE',
  CLEAR_RESERVATION_DETAILS_CABANA_DETAILS: 'CLEAR_RESERVATION_DETAILS_CABANA_DETAILS',
  PACKAGE_RESERVATION_LOADING_ERROR: 'PACKAGE_RESERVATION_LOADING_ERROR',
  GTM_POST_RESERVATION_DETAILS_SALE_PACKAGE_ADDED: 'GTM_POST_RESERVATION_DETAILS_SALE_PACKAGE_ADDED',
  FETCH_RESERVATION_PERSONALIZE_ADDON: 'FETCH_RESERVATION_PERSONALIZE_ADDON',
  CLEAR_CONFIRMATION_RECOMMENDATION: 'CLEAR_CONFIRMATION_RECOMMENDATION',
  FETCH_SUITE_UPGRADE_OFFERS_REQUEST: 'FETCH_SUITE_UPGRADE_OFFERS_REQUEST',
  FETCH_SUITE_UPGRADE_OFFERS_SUCCESS: 'FETCH_SUITE_UPGRADE_OFFERS_SUCCESS',
  FETCH_SUITE_UPGRADE_OFFERS_FAILURE: 'FETCH_SUITE_UPGRADE_OFFERS_FAILURE',
  CLEAR_SUITE_UPGRADE_OFFERS: 'CLEAR_SUITE_UPGRADE_OFFERS',
  FETCH_SUITE_UPGRADE_PREVIEW_REQUEST: 'FETCH_SUITE_UPGRADE_PREVIEW_REQUEST',
  FETCH_SUITE_UPGRADE_PREVIEW_SUCCESS: 'FETCH_SUITE_UPGRADE_PREVIEW_SUCCESS',
  FETCH_SUITE_UPGRADE_PREVIEW_FAILURE: 'FETCH_SUITE_UPGRADE_PREVIEW_FAILURE',
  CLEAR_SUITE_UPGRADE_PREVIEW: 'CLEAR_SUITE_UPGRADE_PREVIEW',
  FETCH_SUITE_UPGRADE_COMMIT_REQUEST: 'FETCH_SUITE_UPGRADE_COMMIT_REQUEST',
  FETCH_SUITE_UPGRADE_COMMIT_SUCCESS: 'FETCH_SUITE_UPGRADE_COMMIT_SUCCESS',
  FETCH_SUITE_UPGRADE_COMMIT_FAILURE: 'FETCH_SUITE_UPGRADE_COMMIT_FAILURE',
  CLEAR_SUITE_UPGRADE_COMMIT: 'CLEAR_SUITE_UPGRADE_COMMIT',
  SET_SUITE_UPGRADED: 'SET_SUITE_UPGRADED'
};

export default manageReservationTypes;
